import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-create-quote',
  templateUrl: './create-quote.component.html',
  styleUrls: ['./create-quote.component.scss']
})
export class CreateQuoteComponent implements OnInit {
  profile = this.appService.getCurrentAccount();
  quoteForm: FormGroup;
  servicesFormArray: FormArray;
  variableJobRateCards: FormArray;
  selectedFileNames: string[] = [];
  maxlengthworkTermsAndConditions = 200;
  leftworkTermsAndConditionsCharacters = 200;
  selectedRow: any = null;
  baseImageUrl = environment.image_url;
  action: string = 'Create';
  isLoading: boolean = false;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  perList: any[] = [
    {
      name: 'Task',
      value: 'Task'
    },
    // {
    //   name: 'PER DURATION',
    //   value: 'PER DURATION'
    // },
    {
      name: 'Hour',
      value: 'Hour'
    },
    {
      name: 'Day',
      value: 'Day'
    },
    {
      name: 'Week',
      value: 'Week'
    },
    {
      name: 'Month',
      value: 'Month'
    },
  ];
  roles = roles;
  entityTypes = entityTypes;

  constructor(
    public dialogRef: MatDialogRef<CreateQuoteComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedProject: any,
    private appService: AppService,
    private _fb: FormBuilder,
    private employerUploadService: EmployerUploadService,
    private jobService: JobService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    console.log(this.selectedProject, this.profile);
    this.quoteForm = this._fb.group({
      servicesFormArray: this._fb.array([
        this.rateCardForm
      ]),
      variableJobRateCards: this._fb.array([]),
      expiryDate: ['', [Validators.required]],
      paymentTerms: ['', [Validators.required]],
      additionalTermsAndConditions: [],
      attachments: this._fb.array([])
    })
    if (this.selectedProject.action == 'Edit') {
      this.selectedRow = this.selectedProject;
      this.action = 'Update';
      this.getProjectById();
    } else {
      this.setInitialValues();
    }
  }

  // get project details by id
  getProjectById() {
    this.isLoading = true;
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      let params = { 'entityId': this.profile.entity.id };
      this.jobService.getJobDetailsById(this.selectedProject.jobId, params).subscribe((job: any) => {
        this.isLoading = false;
        this.selectedProject = job;
        console.log(this.selectedProject, this.selectedRow)
        if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType != 'NONE') {

          this.selectedRow.jobRateCards.forEach(rowItem => {
            const existsInProject = this.selectedProject.rateCards.some(projectItem => projectItem.type === rowItem.type);
            if (!existsInProject) {
              rowItem.isUserAddedRate = true;
              this.selectedProject.rateCards.push(rowItem);
            }
          });

          this.selectedProject.rateCards.forEach(ele => {
            this.selectedRow.jobRateCards.forEach(element => {
              if (ele.type == element.type) {
                ele.yourRate = element.rate;
                ele.proposedAmount = element.totalAmount;
              }
            });
          });

          this.selectedRow.variableJobRateCards.forEach(rowItem => {
            const existsInProject = this.selectedProject.variableJobRateCards.some(projectItem => projectItem.type === rowItem.type);
            if (!existsInProject) {
              rowItem.isUserAddedRate = true;
              this.selectedProject.variableJobRateCards.push(rowItem);
            }
          });

          this.selectedProject.variableJobRateCards.forEach(ele => {
            this.selectedRow.variableJobRateCards.forEach(element => {
              if (ele.type == element.type) {
                ele.yourRate = element.rate;
                ele.proposedAmount = element.totalAmount;
              }
            });
          });
          this.setInitialValues();
        } else {
          this.quoteForm.controls['paymentTerms'].setValidators([]);
          this.quoteForm.controls['paymentTerms'].updateValueAndValidity();
          this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
          this.servicesFormArray.clear();
          this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
          this.variableJobRateCards.clear();
        }

        this.quoteForm.controls['expiryDate'].setValue(new Date(this.selectedRow.quoteConditions.quoteValidity));
        this.quoteForm.controls['paymentTerms'].setValue(this.selectedRow.quoteConditions.paymentTerms);
        this.quoteForm.controls['additionalTermsAndConditions'].setValue(this.selectedRow.quoteConditions.addtional);

        const attachmentsArray = this.quoteForm.get('attachments') as FormArray;
        if (this.selectedRow.attachment && this.selectedRow.attachment.length) {
          this.selectedRow.attachment.forEach(element => {
            attachmentsArray.push(this._fb.control(element));
          });
        }
        this.getQuoteById();
      })
    }
  }

  // get Quote By Id
  getQuoteById() {
    this.jobService.getQuotationById(this.selectedRow.id).subscribe((res: any) => {
      console.log(res)
    })
  }

  get rateCardForm() {
    return this._fb.group({
      type: ['', [Validators.required]],
      rate: [null],
      quantity: [null, [Validators.required]],
      days: [null, [Validators.required]],
      isEdit: [true],
      budgetFromHour4u: [null],
      yourRate: [null, [Validators.required]],
      proposedAmount: [null, [Validators.required]],
    });
  }

  get variableRateCardForm() {
    return this._fb.group({
      type: ['', [Validators.required]],
      rate: [null],
      quantity: [null, [Validators.required]],
      per: [null, [Validators.required]],
      isEdit: [true],
      budgetFromHour4u: [null],
      yourRate: [null, [Validators.required]],
      proposedAmount: [null, [Validators.required]],
    });
  }

  get servicesFormArrayForm() {
    return this.quoteForm.get('servicesFormArray') as FormArray;
  }
  get variableJobRateCardsForm() {
    return this.quoteForm.get('variableJobRateCards') as FormArray;
  }

  // set initial form values
  setInitialValues() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.clear();
    this.selectedProject.rateCards.forEach(element => {
      this.servicesFormArray.push(this.rateCardForm);
    });
    this.servicesFormArray.controls.forEach((ele, index) => {
      this.selectedProject.rateCards.forEach((el, i) => {
        el.isEdit = false;
        el.budgetFromHour4u = el.isUserAddedRate ? "" : el.rate * el.quantity * el.days;
        el.rate = el.isUserAddedRate ? "" : el.rate;
        if (i == index) {
          this.servicesFormArray.controls[index].patchValue(el);
        }
      })
    })

    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.clear();
    this.selectedProject.variableJobRateCards.forEach(element => {
      this.variableJobRateCards.push(this.variableRateCardForm);
    });
    this.variableJobRateCards.controls.forEach((ele, index) => {
      this.selectedProject.variableJobRateCards.forEach((el, i) => {
        el.isEdit = false;
        el.budgetFromHour4u = el.isUserAddedRate ? "" : el.rate * el.quantity;
        el.rate = el.isUserAddedRate ? "" : el.rate;
        if (i == index) {
          this.variableJobRateCards.controls[index].patchValue(el);
        }
      })
    })
  }

  // add more fixed amount fields
  addMoreRateCards() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.push(this.rateCardForm);
  }

  // add more Variable amount fields
  addMoreVariableRateCards() {
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.push(this.variableRateCardForm);
  }

  // Delete picture fields
  deleteRateCard(index) {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.removeAt(index);
    console.log(this.servicesFormArray.length)
  }

  // Delete picture fields
  deleteVariableRateCard(index) {
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.removeAt(index);
    console.log(this.variableJobRateCards.length)
  }

  // get Total Billing
  getTotalBilling() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity * element.days);
      });
    }

    if (this.variableJobRateCards.value.length) {
      this.variableJobRateCards.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity);
      });
    }
    return totalBilling;
  }

  // get Total Proposed Billing
  getTotalProposedBilling() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.proposedAmount);
      });
    }

    if (this.variableJobRateCards.value.length) {
      this.variableJobRateCards.value.forEach(element => {
        totalBilling = totalBilling + (element.proposedAmount);
      });
    }
    return totalBilling;
  }

  // get Total Billing's 18% GST
  applicableGST() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity * element.days);
      });
    }

    if (this.variableJobRateCards.value.length) {
      this.variableJobRateCards.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity);
      });
    }
    return totalBilling * 0.18;
  }

  // get Total Billing's 18% GST
  applicableGSTForProposedAmount() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.proposedAmount);
      });
    }

    if (this.variableJobRateCards.value.length) {
      this.variableJobRateCards.value.forEach(element => {
        totalBilling = totalBilling + (element.proposedAmount);
      });
    }
    return totalBilling * 0.18;
  }

  // get Total final Billing with 18% GST
  getTotalFinalBilling() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity * element.days);
      });
    }

    if (this.variableJobRateCards.value.length) {
      this.variableJobRateCards.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity);
      });
    }
    return totalBilling * 1.18;
  }

  // get Total final Billing with 18% GST
  getTotalFinalBillingForProposedAmount() {
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.proposedAmount);
      });
    }

    if (this.variableJobRateCards.value.length) {
      this.variableJobRateCards.value.forEach(element => {
        totalBilling = totalBilling + (element.proposedAmount);
      });
    }
    return totalBilling * 1.18;
  }


  jobDateChange(event) {

  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const attachmentsArray = this.quoteForm.get('attachments') as FormArray;

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            console.log('File uploaded successfully:', s3File);

            attachmentsArray.push(this._fb.control(s3File.key));
            this.selectedFileNames.push(file.name);
          },
          (error) => {
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }

  // added Propose dRate
  addedProposedRate(index) {
    console.log(index)
    this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.value.forEach((element, i) => {
      if (index == i) {
        console.log(element)
        this.servicesFormArray.controls[i].get('proposedAmount').setValue(element.days * element.quantity * element.yourRate);
      }
    })
  }

  // added Propose dRate for variable
  addedProposedRateForVariableRateCards(index) {
    console.log(index)
    this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.value.forEach((element, i) => {
      if (index == i) {
        console.log(element)
        this.variableJobRateCards.controls[i].get('proposedAmount').setValue(element.quantity * element.yourRate);
      }
    })
  }

  // send Quote
  sendQuote(isDraft: boolean = false) {
    this.isLoading = true;
    console.log(this.selectedProject, this.quoteForm)
    let jobRateCards = [];
    let variableJobRateCards = [];
    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType.includes('FIXED')) {
      if (this.quoteForm.value.servicesFormArray && this.quoteForm.value.servicesFormArray.length) {
        this.quoteForm.value.servicesFormArray.forEach(element => {
          let obj = {
            "type": element.type,
            "quantity": element.quantity,
            "days": element.days,
            "rate": element.yourRate,
            "totalAmount": element.proposedAmount
          }
          jobRateCards.push(obj);
        });
      }
    }
    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType.includes('VARIABLE')) {
      if (this.quoteForm.value.variableJobRateCards && this.quoteForm.value.variableJobRateCards.length) {
        this.quoteForm.value.variableJobRateCards.forEach(element => {
          let obj = {
            "type": element.type,
            "quantity": element.quantity,
            "per": element.per,
            "rate": element.yourRate,
            "totalAmount": element.proposedAmount
          }
          variableJobRateCards.push(obj);
        });
      }
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType == 'VARIABLE') {
      this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
      this.servicesFormArray.clear();
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType == 'FIXED') {
      this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
      this.variableJobRateCards.clear();
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType == 'NONE') {
      this.servicesFormArray = this.quoteForm.get('servicesFormArray') as FormArray;
      this.servicesFormArray.clear();
      this.variableJobRateCards = this.quoteForm.get('variableJobRateCards') as FormArray;
      this.variableJobRateCards.clear();
      this.quoteForm.controls['paymentTerms'].setValidators([]);
      this.quoteForm.controls['paymentTerms'].updateValueAndValidity();
    }

    if (!this.quoteForm.valid) {
      this.quoteForm.markAllAsTouched();
      this.isLoading = false;
      return;
    } else {
      console.log(this.selectedRow)
      if (this.selectedRow && this.selectedRow.id) {
        this.editQuote(isDraft, jobRateCards, variableJobRateCards);
      } else {
        this.addQuote(isDraft, jobRateCards, variableJobRateCards);
      }
    }
  }

  // add quote
  addQuote(isDraft, jobRateCards, variableJobRateCards) {
    const dateString = this.quoteForm.value.expiryDate;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    this.isLoading = true;
    const resultArray: number[] = [year, month, day];
    let obj = {
      "entityId": this.profile.entity.id,
      "jobId": this.selectedProject.id,
      "assignmentId": this.selectedProject.assignmentId,
      "status": isDraft ? "DRAFT" : "PENDING",
      "jobRateCards": jobRateCards,
      "variableJobRateCards": variableJobRateCards,
      "quoteConditions": {
        "quoteValidity": resultArray,
        "paymentTerms": this.quoteForm.value.paymentTerms,
        "addtional": this.quoteForm.value.additionalTermsAndConditions
      },
      "attachments": this.quoteForm.value.attachments
    }
    console.log(obj);
    this.jobService.createQuotation(obj).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      if (res) {
        this.notify.showMessage('Quotation sent successfully!', 2000);
        this.dialogRef.close(true);
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
    }))
  }

  // edit quote
  editQuote(isDraft, jobRateCards, variableJobRateCards) {
    const dateString = this.quoteForm.value.expiryDate;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    this.isLoading = true;
    const resultArray: number[] = [year, month, day];
    let obj = {
      "id": this.selectedRow.id,
      "entityId": this.profile.entity.id,
      "jobId": this.selectedProject.id,
      "assignmentId": this.selectedProject.assignmentId,
      "status": isDraft ? "DRAFT" : "PENDING",
      "jobRateCards": jobRateCards,
      "variableJobRateCards": variableJobRateCards,
      "quoteConditions": {
        "quoteValidity": resultArray,
        "paymentTerms": this.quoteForm.value.paymentTerms,
        "addtional": this.quoteForm.value.additionalTermsAndConditions
      },
      "attachments": this.quoteForm.value.attachments
    }
    console.log(obj);
    this.jobService.updateQuotation(obj).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      if (res) {
        this.notify.showMessage('Quotation update successfully!', 2000);
        this.dialogRef.close(true);
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
    }))
  }

  openDocInNewWindow(url) {
    window.open(url, "_blank");
  }
}
